/**
 * Commerce7 Product Details
 */

export default function C7ProductDetails() {
	const selectors = {
		bundleProductDetails: '.bundle-product-details',
		bundleProductNames: '.bundle-product-names',
	};

	this.init = () => {
		c7.addAction("c7_product_detail_rendered", (content) => {
			// Do something after product detail rendered.

			renderBundleProducts();
			stickyAddToCart();
		});
	};

	/**
	* Render Bundled Products
	*/

	const renderBundleProducts = () => {
		if (jQuery(selectors.bundleProductDetails).length > 0) {
			const id = jQuery(".c7-product__add-to-cart__form__quantity input").attr("id").replace("c7-quantity-", "");

			jQuery.ajax({
				type: "GET",
				url: theme_object.ajax_url,
				data: { action: "get_bundle_items", id },
				success: function (response) {
					if (response["success"]) {
						jQuery(selectors.bundleProductDetails).html(response['content']);
						jQuery(selectors.bundleProductNames).html(response['titles']);
					}
				},
				error: function (err) {
					console.log(err);
				},
			});
		}
	}

	/**
	* Sticky Add To Cart Bar
	*/
	const stickyAddToCart = () => {
		if (jQuery('.product-wine-detail .hwy__c7-product .c7-product__add-to-cart').length) {
			jQuery(document).on('scroll', function() {

				if ( jQuery(this).scrollTop() >= jQuery('.product-wine-detail .hwy__c7-product .c7-product__add-to-cart').position().top + jQuery("header").height()) {
					jQuery( '.sticky-add-to-cart' ).slideDown(300)
				}
				else{
					jQuery( '.sticky-add-to-cart' ).slideUp(300)
				}
			});
		}
	}

}
